import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLanguage } from "@/context/LanguageContext";
import { Clock } from "lucide-react";

const DAYS_IT = ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"];
const DAYS_EN = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export function usePublicInfo() {
  const [info, setInfo] = useState(null);
  useEffect(() => {
    const load = () => api.get("/public-info").then((r) => setInfo(r.data)).catch(() => {});
    load();
    const id = setInterval(load, 60000);
    return () => clearInterval(id);
  }, []);
  return info;
}

export function OpeningBadge({ info, showHours = true, dark = false }) {
  const { t, lang } = useLanguage();
  if (!info) return null;
  const days = lang === "it" ? DAYS_IT : DAYS_EN;
  const rows = Object.entries(info.opening_hours).map(([d, v]) => ({ d: days[Number(d)], v }));
  return (
    <div data-testid="opening-badge" className={`rounded-2xl p-4 ${dark ? "bg-white/10 text-[#F5EFE6]" : "bg-white border border-[#E8DFD5] text-[#1F1615]"}`}>
      <div className="flex items-center gap-2">
        <Clock className="w-4 h-4 text-[#D97706]" />
        <span className="text-sm font-semibold">{t("opening_hours")}</span>
        <span
          data-testid="open-now-status"
          className={`ml-auto text-xs font-bold uppercase tracking-wide rounded-full px-3 py-1 ${info.open_now ? "bg-emerald-100 text-emerald-800" : "bg-red-100 text-red-700"}`}
        >
          {info.open_now ? t("open_now") : t("closed_now")}
        </span>
      </div>
      {showHours && (
        <div className="mt-3 grid grid-cols-2 sm:grid-cols-4 gap-x-4 gap-y-1 text-xs">
          {rows.map(({ d, v }) => (
            <div key={d} className="flex justify-between gap-2">
              <span className="font-semibold">{d}</span>
              <span className={v.closed ? "text-red-500" : dark ? "text-[#F5EFE6]/80" : "text-[#786C66]"}>{v.closed ? t("closed_day") : `${v.open}–${v.close}`}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
